import React, {Component} from 'react';
import styled from 'styled-components';

class Questionmark extends Component {
    render() {
        return (
            <div className={this.props.className}>
                <i className='icon-question'/>
            </div>
        );
    }
}

export default styled(Questionmark)`
  height: 16px;
  width: 16px;
  background-color: ${p => p.theme.cAccent};
  border: 1px solid ${p => p.theme.cBg};
  position: relative;
  border-radius: 50%;
  i{
    display: block;
    position: absolute;
    font-size: 16px;
    color: ${p => p.theme.cWhite};
    left: -1px;
    top: -1px;
  }
`;